export const $planTickboxes = ($availablePlans, tickboxesFactory) => {
  const planTickboxes = tickboxesFactory($availablePlans.items, "plan_id");
  return planTickboxes;
};

$planTickboxes.$inject = ["$availablePlans", "tickboxesFactory"];
